import React from 'react';
import { Container } from 'reactstrap';
import { EasterEgg } from "@/pages/Authentication/EasterEgg";

const Footer = ({ onHeartClick }) => {
    return (
        <React.Fragment>
            <Container fluid>
                <div
                    className='text-muted'
                    style={{
                        textAlign: "center",
                        marginTop: "18px",
                        paddingBottom: "48px",
                        fontSize: "12px",
                        animation: "fadeSlideUp 0.5s ease both",
                        animationDelay: "0.5s",
                    }}>
                    © 2026 Globo Asiatico Patient Assistance Program · Crafted with <i className="mdi mdi-heart text-danger cursor-pointer" onClick={onHeartClick} /> by DXO IT & CyberSecurity Services
                </div>
            </Container>
        </React.Fragment>
    );
};

export default Footer;  